module.exports = __webpack_public_path__ + "static/img/service-03.eb758ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/service-03.jpg
// module id = Hlu2
// module chunks = 13